import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { api } from '@/api'
import type { User, WorkspaceSummary } from '@/types/models'

export const useSessionStore = defineStore('session', () => {
  const user = ref<User | null>(null)
  const currentWorkspace = ref<WorkspaceSummary | null>(null)

  const isAuthenticated = computed(() => user.value !== null)

  function setSession(u: User) {
    user.value = u
    currentWorkspace.value = u.workspace
    localStorage.setItem('user', JSON.stringify(u))
  }

  function clearSession() {
    user.value = null
    currentWorkspace.value = null
    localStorage.removeItem('user')
  }

  async function fetchSession(): Promise<'ok' | 'unauthorized' | 'error'> {
    try {
      const res = await api.get<{ data: User }>('/api/auth/user')
      setSession(res.data.data)
      return 'ok'
    } catch (err: any) {
      // Only clear the session on an explicit 401 — not on 5xx or network errors
      // (e.g. PHP-FPM restarting during a deploy). Clearing on transient errors
      // was forcing a logout on every deploy.
      if (err?.response?.status === 401) {
        clearSession()
        return 'unauthorized'
      }
      return 'error'
    }
  }

  return { user, currentWorkspace, isAuthenticated, setSession, clearSession, fetchSession }
})
